import { store } from "./redux/store";
import { Provider } from "react-redux";
import { WebRoutes } from "./routes";
import { history } from "./utils/history";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import viVN from "antd/lib/locale/vi_VN";

import { ToastContainer } from "react-toastify";

function App() {
  return (
    <ConfigProvider
      locale={viVN}
      theme={
        {
          // token: {
          //   colorFillContent: "#4CBAE6",
          //   colorPrimary: "#4CBAE6",
          //   borderRadius: 12,
          // },
        }
      }
    >
      <PersistGate loading={null} persistor={persistor}>
        <Provider store={store}>
          <BrowserRouter history={history}>
            <WebRoutes />
          </BrowserRouter>
        </Provider>
      </PersistGate>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
      />
    </ConfigProvider>
  );
}

export default App;
